import { fundraisersFragment } from "../lib/graphql/gqlPageDataQuery";
import { GetGroupMembersQuery, GetGroupMembersQueryVariables } from "../lib/graphql/types";
import { Page } from "../lib/pageData";
import { useQuery } from "./useQuery";


const getGroupMembersQuery = /* GraphQL */ `
  ${fundraisersFragment}

  query GetGroupMembers($slug: Slug!, $after: String) {
    page(type: ONE_PAGE, slug: $slug) {
      fundraisers: leaderboard(type: FUNDRAISERS, first: 5, after: $after) {
        ...Fundraisers
      }
    }
  }
`;

export const useFetchGroupMembers = (page: Page) => {
  const { fetchMore, data, loading } = useQuery<
    GetGroupMembersQuery,
    GetGroupMembersQueryVariables
  >(getGroupMembersQuery, {
    initialData: { page, __typename: 'Query' },
  });

  const members = data?.page?.fundraisers;

  function handleFetchMore() {
    fetchMore(
      {
        variables: {
          after: members?.pageInfo.endCursor,
          slug: page.slug!,
        },
      },
      (existing, newData) => {
        if (!existing) {
          return newData;
        }

        const existingMembers = existing.page?.fundraisers?.nodes ?? [];
        const newFundraisers = newData.page?.fundraisers;
        const newMembers = newFundraisers?.nodes ?? [];
        return {
          ...newData,
          page: {
            ...newData.page,
            fundraisers: {
              ...newFundraisers,
              pageInfo: {
                ...newFundraisers?.pageInfo,
                hasNextPage: newFundraisers?.pageInfo.hasNextPage ?? false,
              },
              nodes: [...existingMembers, ...newMembers],
              totalCount: newFundraisers?.totalCount ?? 0,
            },
          },
        };
      },
    );
  }
  return  {data, loading, handleFetchMore}
};
